import { useReducer } from 'react';
import { FrequencyCapsReducer } from './FrequencyCapsReducer';
import {
  defaultContextValues,
  IAction,
  IState,
  FrequencyCapsDispatchContext,
  FrequencyCapsStateContext,
} from './FrequencyCapsContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface IFrequencyCapsProviderProps {
  children: any;
  value?: IValue;
}

export function FrequencyCapsProvider({
  children,
  value = { initialState: defaultContextValues, reducer: FrequencyCapsReducer },
}: IFrequencyCapsProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <FrequencyCapsStateContext.Provider value={state}>
      <FrequencyCapsDispatchContext.Provider value={dispatch}>{children}</FrequencyCapsDispatchContext.Provider>
    </FrequencyCapsStateContext.Provider>
  );
}
